import { HTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ArrayUnitValue, Media } from '../../types';
import { exceptStyledProps, setDeclaration } from '../../utils';
import { Colors } from '../Colors';

export const orientationType = ['horizontal', 'vertical'] as const;

type OrientationType = typeof orientationType[number];

export interface Props extends HTMLAttributes<HTMLDivElement> {
  orientation?: OrientationType;
  margin?: ArrayUnitValue | Media<ArrayUnitValue>;
}

export const Separator = styled('div', exceptStyledProps('color'))<Props>`
  border-width: 0;
  border-style: solid;
  border-color: ${props => props.color || Colors.ut.border10};

  ${({ orientation = 'horizontal', ...props }) => {
    if (orientation === 'vertical') {
      return css`
        ${setDeclaration('margin', props.margin || [0, 10], 'rem')};
        width: 0;
        border-right-width: 1px;
      `;
    }

    return css`
      ${setDeclaration('margin', props.margin || [10, 0], 'rem')};
      height: 0;
      border-bottom-width: 1px;
    `;
  }};
`;
